const hasPower = -1
const halls = [] // 纪念馆
const levels = [] // 纪念馆等级

export default {
  hasPower,
  halls,
  levels
}
